import axiosClient from "../axios/axiosClient";

export function getFaculties() {
  return axiosClient.get("/faculties");
}

export function getFaculty(facultyId) {
  return axiosClient.get(`/faculties/${facultyId}`);
}

export function createFaculty(data) {
  return axiosClient.post("/faculties", data);
}

export const updateFaculty = (facultyId, data) => {
  return axiosClient.put(`/faculties/${facultyId}`, data);
};

export function deleteFaculty(facultyId) {
  return axiosClient.delete(`/faculties/${facultyId}`);
}
